import styled from 'styled-components';
import { ButtonGroup, GroupProps } from '../../components/group';
import colors from '../../style/colors';

interface SplitButtonProps extends GroupProps {
  separator?: 'gray300' | 'action' | 'actionColorDark';
}

export const SplitButtonWrapper = styled((props: SplitButtonProps) => <ButtonGroup {...props} gap={'none'} />)`
  & > button:focus-visible:not(.disabled):not([disabled]) {
    z-index: 1;
  }
  & > button:not(:first-child) {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    border-left-width: 0;
  }
  & > button:not(:last-child) {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    margin-right: 0;
    border-right-width: 0;
  }
  & > button:not(:last-child),
  & > button:hover:not(.disabled):not([disabled]):not(:last-child) {
    ${props => (props?.separator ? `border-right:1px solid ${colors[props.separator]};` : '')}
  }
  & > button:active:not(.disabled):not([disabled]) {
    transform: scale(1);
  }
`;

export default SplitButtonWrapper;
